import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "../../environments/environment"
import { ApiService } from "./api.service"
import {
  LockScheduleDayPayload,
  LockScheduleDayResponse,
  StationLockoutsResponse,
  UnlockScheduleDayPayload,
  UnlockScheduleDayResponse,
} from "../models/lockout.model"
import { StationSchedule } from "./station-schedule.service"

@Injectable({
  providedIn: "root",
})
export class LockoutService {
  private readonly base = environment.apiUrl

  constructor(private api: ApiService) {}

  lockScheduleDay(stationId: number, payload: LockScheduleDayPayload): Observable<LockScheduleDayResponse> {
    return this.api.post<LockScheduleDayResponse>(
      `${this.base}/stations/${stationId}/lockout`,
      payload,
    )
  }

  getLockedDates(stationId: number): Observable<StationLockoutsResponse> {
    return this.api.get<StationLockoutsResponse>(`${this.base}/stations/${stationId}/lockouts`)
  }

  unlockScheduleDay(stationId: number, payload: UnlockScheduleDayPayload): Observable<UnlockScheduleDayResponse> {
    return this.api.delete<UnlockScheduleDayResponse>(
      `${this.base}/stations/${stationId}/lockout`,
      payload,
    )
  }

  getLockedSchedules(params: {
    stationid?: number
    date?: string
    start_date?: string
    end_date?: string
    limit?: number
    offset?: number
  }): Observable<{ schedules: StationSchedule[]; pagination?: { total: number } }> {
    const q = new URLSearchParams()
    q.set("locked_only", "true")
    if (params.stationid != null) q.set("stationid", String(params.stationid))
    if (params.date) q.set("date", params.date)
    else {
      if (params.start_date) q.set("start_date", params.start_date)
      if (params.end_date) q.set("end_date", params.end_date)
    }
    if (params.limit != null) q.set("limit", String(params.limit))
    if (params.offset != null) q.set("offset", String(params.offset))
    return this.api.authenticatedGet(`${this.base}/stationSchedules?${q.toString()}`)
  }
}
